import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/header/header.component';

@Component({
  selector: 'app-brand-guide',
  standalone: true,
  imports: [CommonModule, HeaderComponent],
  templateUrl: './brand-guide.component.html',
})
export class BrandGuideComponent {
  copied = '';

  readonly estabelecimentosDefault = '[1009, 1007, 1005, 1004, 1003, 1002, 1001, 627, 280, 279, 277, 276, 274, 273, 272, 241, 103, 22, 4227]';

  readonly modelClinicaSim = `{
  "sidebarBg":           "#101820",
  "accentColor":         "#8B5CF6",
  "textOnPrimary":       "#FFFFFF",
  "pageTitle":           "POS - Clínica SiM",
  "supportEmail":        "ti@clinicasim.com",
  "favicon":             "",
  "footerLogo":          "",
  "footerTagline":       "healthcare platform",
  "footerCopyright":     "Copyright © SiMCo. All Rights Reserved",
  "loginCardBg":         "#FFFFFF",
  "loginCardText":       "#333333",
  "cdEmpresa":           "2",
  "estabelecimentosIds": "[1009, 1007, 1005, 1004, 1003, 1002, 1001, 627, 280, 279, 277, 276, 274, 273, 272, 241, 103, 22, 4227]"
}`;

  readonly modelSuperClinica = `{
  "sidebarBg":           "#0F1F3E",
  "accentColor":         "#E8001E",
  "textOnPrimary":       "#FFFFFF",
  "pageTitle":           "POS - Super Clínica",
  "supportEmail":        "ti@superclinica.com.br",
  "favicon":             "https://cdn.prod.website-files.com/624adfce4249ed434a0ef8c1/624b0310d0b27a5f0debcfca_logo_super-clinica_red-white.svg",
  "footerLogo":          "https://cdn.prod.website-files.com/624adfce4249ed434a0ef8c1/624b0310d0b27a5f0debcfca_logo_super-clinica_red-white.svg",
  "footerTagline":       "healthcare platform",
  "footerCopyright":     "Copyright © 2024 M & L Serviços em Saúde Ltda.",
  "loginCardBg":         "#0F1F3E",
  "loginCardText":       "#FFFFFF",
  "cdEmpresa":           "2",
  "estabelecimentosIds": "[1009, 1007, 1005, 1004, 1003, 1002, 1001, 627, 280, 279, 277, 276, 274, 273, 272, 241, 103, 22, 4227]"
}`;

  copy(text: string, key: string) {
    navigator.clipboard.writeText(text);
    this.copied = key;
    setTimeout(() => this.copied = '', 2000);
  }
}
